export const state = () => ({
  controlledPromise: {
    promise: null,
    resolve: null,
    reject: null,
  },
});

export const getters = {
  getControlledPromise(state) {
    return state.controlledPromise;
  },
};

export const mutations = {
  SET_CONTROLLED_PROMISE(state, { promise, resolve, reject }) {
    state.controlledPromise.promise = promise;
    state.controlledPromise.resolve = resolve;
    state.controlledPromise.reject = reject;
  },
};

export const actions = {
  createControlledPromise({ commit }) {
    let resolveFunc;
    let rejectFunc;

    const promise = new Promise((resolve, reject) => {
      resolveFunc = (e) => {
        resolve(e);
        commit("SET_CONTROLLED_PROMISE", { promise: null, resolve: null, reject: null });
      };
      rejectFunc = (e) => {
        reject(e);
        commit("SET_CONTROLLED_PROMISE", { promise: null, resolve: null, reject: null });
      };
    });

    commit("SET_CONTROLLED_PROMISE", { promise, resolve: resolveFunc, reject: rejectFunc });
    return promise;
  },
};
